// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

import { api } from "@/api/endpoints";
import { useCursorList } from "@/hooks/useCursorList";

/** Filing choices are filtered on the server before pagination. */
export function useAvailableBoms(productTypeId: string, enabled = true) {
  const filters = { status: "PUBLISHED" as const, is_disabled: false };
  const query = useCursorList(
    ["boms", productTypeId, filters],
    (cursor) => api.boms.list(productTypeId, { ...filters, limit: 50, cursor }),
    { enabled: Boolean(productTypeId) && enabled },
  );
  return {
    ...query,
    items: query.items.filter((bom) => bom.status === "PUBLISHED" && !bom.disabled_at),
  };
}
